import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import map from 'lodash/map';
import { stringify, parse } from 'qs';
import { LOCALES } from '~/const/i18n';
import { CATEGORY_INFIX, PRODUCT_INFIX } from '~/const/infix';
var PRODUCTS_PER_PAGE = 40;

var buildEditorialCanonical = function buildEditorialCanonical(base, path) {
  return {
    rel: 'canonical',
    href: "".concat(base).concat(path)
  };
};

var buildEditorialAlternates = function buildEditorialAlternates(base, type, slug) {
  var useAlias = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var noType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var currentSlug = slug ? "/".concat(slug) : '';
  var currentType = '';
  var trailingSlash = '';

  if (noType === false) {
    currentType = useAlias !== false ? "e/".concat(useAlias) : "e/".concat(type);
    trailingSlash = '/';
  }

  return map(LOCALES, function (locale) {
    return {
      rel: 'alternate',
      hreflang: locale.iso ? locale.iso.toLowerCase() : '',
      href: "".concat(base, "/").concat(locale.market, "/").concat(locale.language).concat(trailingSlash).concat(currentType).concat(currentSlug)
    };
  });
};

var buildUrl = function buildUrl(urlbaseArray) {
  var queryString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var currentPath = urlbaseArray.join('/');
  var queryParams = queryString ? "?".concat(queryString) : '';
  var queryExtension = extension ? "".concat(extension) : '';
  return "".concat(currentPath).concat(queryExtension).concat(queryParams);
};

var buildCategoryNextLink = function buildCategoryNextLink(locale, base, alias, total, pagination) {
  var facet = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var predicate = total - pagination * PRODUCTS_PER_PAGE; // Current facet value is already a query param

  var facetParsed = parse(facet);
  var page = pagination + 1;
  var queryString = stringify(_objectSpread({}, predicate > 0 && {
    page: page
  }, predicate > 0 && facetParsed));
  return predicate > 0 ? {
    rel: 'next',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  } : null;
};

var buildCategoryPrevLink = function buildCategoryPrevLink(locale, base, alias, pagination) {
  var facet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  // Current facet value is already a query param
  var facetParsed = parse(facet);
  var page = pagination - 1;
  var queryString = stringify(_objectSpread({}, pagination > 2 && {
    page: page
  }, facetParsed));
  return pagination > 1 ? {
    rel: 'prev',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  } : null;
};

var buildCategoryCanonical = function buildCategoryCanonical(locale, base, alias, page, facet) {
  // Current facet value is already a query param
  var facetParsed = parse(facet);
  var queryString = stringify(_objectSpread({}, page > 1 && {
    page: page
  }, facetParsed));
  return {
    rel: 'canonical',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  };
};

var buildCategoryAlternates = function buildCategoryAlternates(base, aliases, hash, page) {
  var facet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  // Current facet value is already a query param
  var facetParsed = parse(facet);
  var queryString = stringify(_objectSpread({}, page > 1 && {
    page: page
  }, facetParsed));
  return map(LOCALES, function (locale) {
    return {
      rel: 'alternate',
      hreflang: locale.iso ? locale.iso.toLowerCase() : '',
      href: locale && locale.language && locale.market ? buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, "".concat(aliases[locale.language.toLowerCase()], "-").concat(hash)], queryString) : ''
    };
  });
};

var buildProductAlternates = function buildProductAlternates(base, slugs, reference) {
  return map(LOCALES, function (locale) {
    return {
      rel: 'alternate',
      hreflang: locale.iso ? locale.iso.toLowerCase() : '',
      href: locale && locale.language && locale.market ? buildUrl([base, locale.market, locale.language, PRODUCT_INFIX, "".concat(slugs[locale.language.toLowerCase()], "-").concat(reference)], '', '.htm') : ''
    };
  });
};

var buildUniqueClassName = function buildUniqueClassName(prefix, label) {
  return "".concat(prefix, "-").concat(label.replace(/[ ,.]+/g, '-').toLowerCase());
};

export { buildEditorialCanonical, buildEditorialAlternates, buildCategoryNextLink, buildCategoryPrevLink, buildCategoryCanonical, buildCategoryAlternates, buildProductAlternates, buildUniqueClassName };